export default __webpack_public_path__ + "static/media/game-icon-active.6e126893.webp";